import { AppIcon } from '../components/icons/icon.type';

export interface UIItemType<T> {
  name: string;
  data: T;
  icon?: AppIcon | string;
  isoCode?: string;
}

export interface FormValueProvider {
  toFormValue(): string;
}

export type UiItemTypes = string | number | object | FormValueProvider;

export class UIItem<T extends UiItemTypes = object> implements UIItemType<T> {
  get name(): string {
    return this.itemName;
  }

  get data(): T {
    return this.itemValue;
  }

  get icon(): AppIcon | string | undefined {
    return this.itemIcon;
  }

  get isoCode(): string | undefined {
    return this.itemIsoCode;
  }

  disabled?: boolean;

  constructor(
    private itemName: string,
    private itemValue: T,
    private itemIcon?: AppIcon | string,
    private itemIsoCode?: string,
  ) {}

  toString() {
    const data = this.data as FormValueProvider;
    return data.toFormValue ? data.toFormValue() : this.name.toString();
  }
}
